import React, { Component, PropTypes } from 'react';
import * as Colors from 'components/Material/Styles/Colors';
import * as Icons from 'components/Material/SvgIcons';
import { Styles } from 'material-ui';
import ResponsiveImage from 'components/ResponsiveImage';

const { Spacing } = Styles;

const iconSize = Spacing.desktopKeylineIncrement * 1.5;

const styles = {
  iconContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    textAlign: 'center'
  }
};

export default class Cover extends Component {
  static propTypes = {
    opacity: PropTypes.number,
    imageOpacity: PropTypes.number,
    height: PropTypes.number,
    defaultIcon: PropTypes.string,
    backgroundColor: PropTypes.string
  };

  static defaultProps = {
    defaultIcon: 'ImageImage',
    backgroundColor: Colors.Colors.grey[500].material,
    height: 246,
    opacity: 1,
    imageOpacity: 1,
    noImage: false
  };

  getIconStyle(imageHeight) {
    return Object.assign({}, styles.iconContainer, {
      padding: (imageHeight - iconSize) / 2
    });
  }

  render() {
    const {
      backgroundColor,
      height,
      image,
      children,
      defaultIcon,
      noImage,
      imageOpacity,
      style,
      ...other
    } = this.props;
    let coverStyle;
    let icon;
    if (image) {
      coverStyle = Object.assign(
        {
          position: 'relative',
          display: 'block',
          height,
          opacity: this.props.opacity
        },
        style
      );
      return (
        <ResponsiveImage
          key={image}
          style={coverStyle}
          src={image}
          opacity={imageOpacity}
          {...other}
        >
          {icon}
          {children}
        </ResponsiveImage>
      );
    }

    coverStyle = Object.assign(
      {
        position: 'relative',
        boxSizing: 'border-box',
        height
      },
      style
    );
    if (backgroundColor) {
      coverStyle.backgroundColor = backgroundColor;
    }
    const Icon = Icons[defaultIcon];
    if (!noImage && !image) {
      icon = (
        <div style={this.getIconStyle(height)}>
          <Icon
            color={Colors.Colors.grey[700].material}
            style={{ width: iconSize, height: iconSize }}
          />
        </div>
      );
    }
    return (
      <div style={coverStyle} {...other}>
        {icon}
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/Cover.js